import { render, staticRenderFns } from "./TouchLayout.vue?vue&type=template&id=74ab9315&"
import script from "./TouchLayout.vue?vue&type=script&lang=js&"
export * from "./TouchLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports